<!--
/*******************************************************************************
*@ 컴포넌트명   : Drwot.vue
*@ 컴포넌트설명 : 입금계좌 selectbox - option에 사용되는 template
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <fragment>
    <!-- 계좌별칭 -->
    <span
      :class="[data.obaobDstcd == $config.OBAOB_DSTCD_2?'name':'stit']"
      v-if="!_.isEmpty(data.alias)"
    >{{data.alias}}</span>
    <!-- 예금주명 -->
    <span
      :class="[data.obaobDstcd == $config.OBAOB_DSTCD_2?'name':'stit']"
      v-else-if="!_.isNil(data.draweFname)"
    >{{data.draweFname}}</span>
    <!-- 계좌번호 -->
    {{ mnrcv =='latest' ? data.cupldAcno : data.acno }}
    ({{mnrcv =='latest' ? data.cupldCncycd : data.cncycd}})
    <!-- 날짜 -->
    <span
      class="date"
      v-if="!_.isNil(data.sysLastPrcssYMS)"
    >{{$getGlobalDateYmd(data.sysLastPrcssYMS)}}</span>
    <!-- 금액 -->
    <div class="amount highlight" v-if="!_.isNil(data.mrvamt)">
      <span class="exchange-unit">{{data.cncycd}}</span>
      <span class="total" v-html="$num(mnrcv =='latest' ? data.drwotAmt : data.mrvamt)"></span>
    </div>
    <!-- 타은행명 -->
    <span
      class="bank-name"
      v-if="data.obaobDstcd == $config.OBAOB_DSTCD_2 && !_.isNil(data.othrBnkName)"
    >{{data.othrBnkName}}</span>
  </fragment>
</template>
<script>
import { Fragment } from "vue-fragment";
export default {
  components: { Fragment },
  props: {
    data: Object,
    mnrcv: { type: String, default: "" },
  },
};
</script>